import * as Yup from 'yup';
// project import
import {
    FormConfigBuilder,
    GLOBAL_FIELD_PROPS,
} from 'components/form-builder/FormConfigBuilder';

import { DataEntry } from 'models/nostradamus/administration/DataEntry';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import { EventTypeConfig } from 'constants/const/EventTypeConfig';
import { Survey } from 'models/nostradamus/moral-psychological-support/Survey';
import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
import ActionCopyValue from 'components/shared/table/custom-actions/ActionCopyValue';
import { Typography } from '@mui/material';
import { LinkOutlined } from '@ant-design/icons';

const schema = Yup.array(Yup.string());

// eslint-disable-next-line no-unused-vars
const formConfig = (methods = null, watch = null, mode = null) => {
    return new FormConfigBuilder(
        [
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'name',
                title: 'Survey Name',
                validations: [['required', true]],
                // col: {
                //     sm: 6,
                // },
                // optionConfig: {
                //     key: "id",
                //     value: "id",
                //     label: "name",
                // },
                // options: EventTypeConfig,
                list: {
                    headerName: 'Survey name',
                    sorting: true,
                    filtering: true,
                    // minWidth: 300
                },
            },
            {
                componentType:
                    FormFieldCustomComponentTypes.CustomDateTimePicker,
                attribute: 'started_at',
                title: 'Start',
                validations: [['required', true]],
                // list: {
                //     headerName: "Start",
                // },
            },
            {
                componentType:
                    FormFieldCustomComponentTypes.CustomDateTimePicker,
                attribute: 'finished_at',
                title: 'End',
                // validations: [["required", true]],
                // list: {
                //     headerName: "End",
                // },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'unit',
                title: 'Company/Battalion',
                // validations: [["required", true]],
                list: {
                    headerName: 'Company/Battalion',
                },
            },
            {
                componentType: FormFieldCustomComponentTypes.TextField,
                attribute: 'link',
                title: 'Link',
                hideCondition: true,
                list: {
                    headerName: 'Link',
                    renderCell: params =>
                        params.value && (
                            <ActionCopyValue
                                value={params?.value}
                                title={'Copy'}
                                // title={"Copy"}
                            >
                                <Typography
                                    variant="body1"
                                    // color="secondary"
                                    // component="span"
                                    sx={{
                                        cursor: 'pointer',
                                        color: 'primary.main',
                                        '&:hover': { color: 'primary.dark' },
                                    }}
                                >
                                    <LinkOutlined /> {params.value}
                                </Typography>
                            </ActionCopyValue>
                        ),
                },
            },
        ],
        Survey,
    );
};

const config = [{ config: formConfig }];

export default config;
